import { render } from "./App.vue?vue&type=template&id=2ed916da"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2ed916da&lang=scss"
script.render = render

export default script